const t = {
  name: "EnterKey",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 6H17.0002C18.657 6 20.0002 7.34315 20.0002 9V13C20.0002 14.6569 18.657 16 17.0002 16H7.41436L10.4144 19L9.00015 20.4142L3.58594 15L9.00015 9.58579L10.4144 11L7.41436 14H17.0002C17.5524 14 18.0002 13.5523 18.0002 13V9C18.0002 8.44772 17.5524 8 17.0002 8H12.0002V6Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as EnterKey
};
